import { Link } from "react-router-dom";
import SectionHeading from "@/components/base/SectionHeading";
import { newsList } from "@/mocks/news";

export default function NewsSection() {
  const items = newsList.slice(0, 6);
  const [featured, ...rest] = items;

  return (
    <section>
      <SectionHeading
        icon="ri-newspaper-line"
        title="最新资讯精选"
        desc="影视、音乐、综艺、八卦，每日持续更新"
        actionTo="/news"
        actionLabel="查看全部"
      />

      <div className="grid grid-cols-1 gap-5 lg:grid-cols-2">
        {/* Featured */}
        <Link
          to={`/detail/${featured.id}`}
          className="group relative block overflow-hidden rounded-lg border border-background-200 bg-background-100"
        >
          <div className="relative h-56 w-full overflow-hidden md:h-72">
            <img
              src={featured.cover}
              alt={featured.title}
              title={`${featured.title} - 天天干天天干`}
              className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
            />
            <span className="absolute left-4 top-4 rounded-full bg-accent-500 px-3 py-1 text-xs font-medium text-background-50">
              {featured.category}
            </span>
          </div>
          <div className="p-5">
            <h3 className="text-base font-bold leading-snug text-foreground-950 group-hover:text-primary-700 md:text-lg">
              {featured.title}
            </h3>
            <p className="mt-2 line-clamp-2 text-sm leading-relaxed text-foreground-600">
              {featured.summary}
            </p>
            <div className="mt-4 flex items-center gap-3 text-xs text-foreground-400">
              <span>{featured.author}</span>
              <span className="h-1 w-1 rounded-full bg-foreground-300"></span>
              <span>{featured.date}</span>
            </div>
          </div>
        </Link>

        {/* List */}
        <div className="flex flex-col divide-y divide-background-200 rounded-lg border border-background-200 bg-background-100">
          {rest.map((item) => (
            <Link
              key={item.id}
              to={`/detail/${item.id}`}
              className="group flex items-center gap-4 p-4 transition-colors hover:bg-background-50"
            >
              <div className="h-20 w-28 shrink-0 overflow-hidden rounded-md">
                <img
                  src={item.cover}
                  alt={item.title}
                  title={`${item.title} - 天天干天天干`}
                  className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
              </div>
              <div className="min-w-0 flex-1">
                <h3 className="line-clamp-2 text-sm font-semibold leading-snug text-foreground-900 group-hover:text-primary-700">
                  {item.title}
                </h3>
                <div className="mt-2 flex items-center gap-2 text-xs text-foreground-400">
                  <span className="rounded bg-secondary-100 px-2 py-0.5 text-secondary-900">
                    {item.category}
                  </span>
                  <span>{item.date}</span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}